<template>
  <div class="el-collapse-item" :class="{'is-active': isActiveState}" :name="name">
    <div
      role="tab"
      :aria-expanded="isActiveState"
      :qaid="qaidValue"
      :aria-controls="`el-collapse-content-${id}`"
      :aria-describedby="`el-collapse-content-${id}`"
    >
      <div
        :id="`el-collapse-head-${id}`"
        class="el-collapse-item__header"
        :class="[
          {
            focusing: focusing,
            'is-active': isActiveState,
            'flex-row-reverse': iconLeft,
          },
          `items-${collapse.alignIcon}`,
          collapse.headerClasses,
        ]"
        role="button"
        tabindex="0"
        @click="handleHeaderClick"
        @keyup.space.enter.stop="handleEnterClick"
        @focus="handleFocus"
        @blur="focusing = false"
      >
        <div class="flex items-center flex-grow">
          <slot name="title">{{ title }}</slot>
        </div>

        <slot name="icon">
          <i
            v-if="!disabled"
            class="material-icons el-collapse-item__icon"
            :qaid="qaidChevronValue"
            :class="[
              {
                'is-active': isActiveState,
              },
              collapse.iconClasses,
            ]"
            >{{ isActiveState ? collapse.iconActive : collapse.iconInactive }}</i
          >
        </slot>
      </div>
    </div>

    <el-collapse-transition :is-enabled="isEnableTransition">
      <div
        v-show="isActiveState"
        :id="`el-collapse-content-${id}`"
        class="el-collapse-item__wrap"
        role="tabpanel"
        :aria-hidden="!isActiveState"
        :aria-labelledby="`el-collapse-head-${id}`"
      >
        <div class="el-collapse-item__content" :class="[collapse.contentClasses]">
          <slot></slot>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import ElCollapseTransition from '../transitions/collapse-transition';
import Emitter from '../mixins/emitter';

export default {
  name: 'ElCollapseItem',
  componentName: 'ElCollapseItem',
  components: {ElCollapseTransition},
  mixins: [Emitter],

  props: {
    title: {
      type: String,
      default: '',
    },
    qaid: {
      type: String,
      default: '',
    },
    name: {
      type: [String, Number],
      default() {
        return this._uid;
      },
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isEnableTransition: {
      type: Boolean,
      default: true,
    },
    disabled: Boolean,
  },

  data() {
    return {
      contentWrapStyle: {
        height: 'auto',
        display: 'block',
      },
      contentHeight: 0,
      focusing: false,
      isClick: false,
    };
  },

  inject: ['collapse'],

  computed: {
    qaidChevronValue() {
      if (!this.qaid || !this.qaid.length) {
        return '';
      }

      return `${this.qaid}${this.isActiveState ? 'ChevronExpanded' : 'ChevronCollapsed'}`;
    },
    qaidValue() {
      if (!this.qaid || !this.qaid.length) {
        return '';
      }

      return `${this.qaid}${this.isActiveState ? 'Expanded' : 'Collapsed'}`;
    },

    isActiveState() {
      return this.collapse.activeNames.indexOf(this.name) > -1;
    },

    id() {
      return Math.random()
        .toString(36)
        .substring(7);
    },

    iconLeft() {
      return this.collapse.iconPosition === 'left';
    },
  },

  watch: {
    isActive(value) {
      const activeIndex = this.collapse.activeNames.indexOf(this.name);
      if (value && activeIndex < 0) {
        this.collapse.activeNames.push(this.name);
      } else if (!value && activeIndex > -1) {
        this.collapse.activeNames = this.collapse.activeNames.filter((item) => item !== this.name);
      }
    },

    isActiveState(value) {
      this.$emit('state-changed', value);
    },
  },

  mounted() {
    if (this.collapse.defaultActive || this.isActive) {
      this.collapse.activeNames.push(this.name);
      this.collapse.allNames.push(this.name);
    }
  },

  methods: {
    handleFocus() {
      setTimeout(() => {
        if (!this.isClick) {
          this.focusing = true;
        } else {
          this.isClick = false;
        }
      }, 50);
    },

    handleHeaderClick() {
      if (!this.disabled) {
        this.dispatch('ElCollapse', 'item-click', this);
        this.focusing = false;
        this.isClick = true;
      }
    },

    handleEnterClick() {
      if (!this.disabled) {
        this.dispatch('ElCollapse', 'item-click', this);
      }
    },
  },
};
</script>
